export default {
  menu: true,
  collapsedMenu: false,
  sessionMenu: true,
  notification: {
    visible: false,
    message: '',
  },
}
